import { useState } from "react";
import { FiX, FiFacebook, FiInstagram, FiYoutube } from "react-icons/fi";
import { BsTelephoneFill } from "react-icons/bs";
import { MdEmail } from "react-icons/md";
import { RiMenu3Fill } from "react-icons/ri";
import { NavLink } from "react-router-dom";

interface NavbarProps {
  scrollToSection: (section: string) => void;
}

const Navbar: React.FC<NavbarProps> = ({ scrollToSection }) => {
  const [open, setOpen] = useState(false);

  const handleClick = (section: string) => {
    scrollToSection(section);
    setOpen(false);
  };

  return (
    <header className="w-full">
      {/* ================= TOPBAR ================= */}
      <div className="hidden md:flex justify-between items-center bg-gray-100 text-gray-600 text-sm px-6 py-2">
        <div className="flex items-center gap-6">
          <div className="flex items-center gap-2">
            <BsTelephoneFill /> +6285655556864
          </div>
          <div className="flex items-center gap-2">
            <MdEmail /> admin@patunganindonesia.com
          </div>
        </div>

        <div className="flex items-center gap-3">
          <span className="mr-2">Follow Us On:</span>
          <FiFacebook className="cursor-pointer" />
          <FiInstagram className="cursor-pointer" />
          <FiYoutube className="cursor-pointer" />
        </div>
      </div>

      {/* ================= MAIN NAVBAR ================= */}
      <div className="bg-white shadow-sm">
        <div className="px-4 md:px-6 lg:px-10 h-[74px] flex items-center justify-between">
          {/* LOGO */}
          <div onClick={() => handleClick("beranda")} className="flex items-center gap-3 cursor-pointer">
            <img src="/images/logo.png" alt="Logo" className="h-10 md:h-12 object-contain" />
          </div>

          {/* MENU DESKTOP */}
          <nav className="hidden lg:flex items-center gap-8 text-gray-700 font-medium">
            <button onClick={() => handleClick("beranda")} className="hover:text-secondary transition">
              Beranda
            </button>

            <button onClick={() => handleClick("fitur")} className="hover:text-secondary transition">
              Patungan Cepat
            </button>

            <button onClick={() => handleClick("kategori")} className="hover:text-secondary transition">
              Kategori
            </button>

            <button onClick={() => handleClick("campaign")} className="hover:text-secondary transition">
              Campaign
            </button>

            <button onClick={() => handleClick("fokus")} className="hover:text-secondary transition">
              Fokus
            </button>
          </nav>

          {/* RIGHT BUTTON */}
          <div className="hidden lg:flex items-center gap-3">
            <NavLink to="https://patunganindonesia.online/login/inspirator" className="bg-secondary text-white px-6 py-2.5 rounded-full font-semibold">
              Masuk
            </NavLink>

            <NavLink to="https://patunganindonesia.online/inspirator/register" className="border border-secondary text-secondary px-6 py-2.5 rounded-full font-semibold">
              Daftar
            </NavLink>
          </div>

          {/* HAMBURGER */}
          <button className="lg:hidden" onClick={() => setOpen(!open)}>
            {open ? <FiX size={28} /> : <RiMenu3Fill size={28} />}
          </button>
        </div>
      </div>

      {/* ================= MOBILE MENU ================= */}
      <div className={`lg:hidden fixed top-[74px] left-0 w-full bg-white shadow-md transition-all duration-300 ${open ? "max-h-screen py-6" : "max-h-0 overflow-hidden"}`}>
        <div className="flex flex-col items-center gap-5 text-gray-700 font-medium">
          <button onClick={() => handleClick("beranda")}>Beranda</button>
          <button onClick={() => handleClick("fitur")}>Patungan Cepat</button>
          <button onClick={() => handleClick("kategori")}>Kategori</button>
          <button onClick={() => handleClick("campaign")}>Campaign</button>
          <button onClick={() => handleClick("Fokus")}>Fokus</button>

          <NavLink to="/login" className="bg-secondary text-white px-6 py-2 rounded-full" onClick={() => setOpen(false)}>
            Masuk
          </NavLink>

          <NavLink
            to="https://patunganindonesia.online/inspirator/register"
            className="border border-secondary text-secondary hover:bg-green-800 hover:text-white px-6 py-2.5 rounded-full font-semibold transition"
            onClick={() => setOpen(false)}>
            Daftar
          </NavLink>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
